export const useDashboardStore = defineStore('dashboardStore', {
  state: () => ({
    vibrantColors: [
      '#FF6347', // Tomato
      '#00BFFF', // DeepSkyBlue
      '#32CD32', // LimeGreen
      '#FF8C00', // DarkOrange
      '#9370DB', // MediumPurple
      '#00CED1', // DarkTurquoise
      '#FFD700', // Gold
      '#8A2BE2', // BlueViolet
      '#228B22', // ForestGreen
      '#FF69B4' // HotPink
    ],
    receitas: {} as any,
    despesas: [] as any[],
    contasAlertas: [] as any[],
    filtros: {
      dataInicio: '',
      dataFim: '',
      filtrarPor: 'mes',
    },
    loading: false,
    // Estado para comparação de receitas por atos
    comparacaoReceitas: {
      mesAtual: new Date().toISOString().slice(0, 7),
      periodosComparacao: [] as string[],
      atosSelecionados: [] as any[],
    },
  }),
  actions: {
    async fetchReceitasPorPeriodo (dataInicio: string, dataFim: Date) {
      const url = `/gerencia/financeiro/caixa/TODOS/${dataInicio}/${dataFim}`
      const receitas = await useApiStore().request(url) as any
      // create an array from receitas.caixa
      return Object.entries(receitas.caixa).map(([key, value]) => ({ [key]: value }))
    },
    async fetchReceitasPorFiltroPeriodo (filtrarPor: string, competencia: string) {
      const url = `/financeiro/dashboard/receitas/${filtrarPor}/${competencia}`
      const receitas = await useApiStore().request(url) as any
      // create an array from receitas.caixa
      this.receitas = receitas
      return receitas
    },
    async fetchReceitasComparacaoPorCompetencia (competencia: string) {
      const url = `/financeiro/dashboard/receitas/mes/${competencia}`
      const receitas = await useApiStore().request(url) as any
      return receitas
    },
    async fetchContasAPagarPorPeriodo (dataInicio: string, dataFim: Date) {
      const url = `/financeiro/dashboard/despesas/${dataInicio}/${dataFim}`
      const contasAPagar = await useApiStore().request(url) as any[]
      this.despesas = contasAPagar.filter((conta: any) => conta.conta.tipo.toLowerCase() === 'dedutivel')
      return this.despesas
    },
    async fetchContasParaAlertas () {
      // Busca contas desde o início dos tempos até 1 mês no futuro para capturar todas as contas relevantes
      const hoje = new Date()
      const umMesNoFuturo = new Date()
      umMesNoFuturo.setMonth(hoje.getMonth() + 1)

      // Data de início bem antiga para pegar todas as contas históricas
      const dataInicio = '1900-01-01'
      const dataFim = umMesNoFuturo.toISOString().split('T')[0]

      const url = `/financeiro/dashboard/despesas/${dataInicio}/${dataFim}`
      const contasAPagar = await useApiStore().request(url) as any[]

      // Filtra apenas contas dedutíveis não pagas
      const contasAlertas = contasAPagar.filter((conta: any) =>
        conta.conta.tipo.toLowerCase() === 'dedutivel' && conta.data_pagamento === null
      )

      this.contasAlertas = contasAlertas
      return contasAlertas
    },
  },
  getters: {
    getCoresAleatorias: state => (quantidade: number) => {
      const cores = []
      for (let i = 0; i < quantidade; i++) {
        cores.push(state.vibrantColors[Math.floor(Math.random() * state.vibrantColors.length)])
      }
      return cores
    },
    getCoresPorQuantidade: state => (quantidade: number) => {
      return state.vibrantColors.slice(0, quantidade)
    },
    getTotalDespesas (state) {
      return state.despesas?.filter(despesa => despesa.conta?.tipo.toLowerCase() === 'dedutivel').reduce((acc, despesa) => {
        return parseFloat(despesa.valor.toString().replace(',', '.')) + acc
      }, 0)
      // return state.despesas?.reduce((acc, despesa) => parseFloat((despesa.valor - despesa.tfj - despesa.iss - despesa.funcivil - despesa.fundo_eletronizacao).toString().replace(',', '.')) + acc, 0)
    },
    getTotalReceitas (state) {
      const totalReceitas = state.receitas?.receitas_gise?.reduce((acc: number, receita: any) => parseFloat(receita.emolumento.toString().replace(',', '.')) + acc, 0) ?? 0
      const totalReceitasExtras = state.receitas?.receitas_extra?.reduce((acc: number, receita: any) => parseFloat(receita.valor.toString().replace(',', '.')) + acc, 0) ?? 0
      const totalReceitasBpo = state.receitas?.receitas_bpo?.reduce((acc: number, receita: any) => parseFloat(receita.valor.replace(',', '.')) + acc, 0) ?? 0
      return totalReceitas + totalReceitasExtras + totalReceitasBpo
    },
    getTotalDespesasNaoDedutiveis (state) {
      return state.despesas?.filter(despesa => despesa.conta?.tipo.toLowerCase() !== 'dedutivel').reduce((acc, despesa) => {
        return parseFloat(despesa.valor.toString().replace(',', '.')) + acc
      }, 0)
    },
    getTotalRepasses (state) {
      return state.receitas?.receitas_gise?.reduce((acc: number, receita: any) => {
        return (parseFloat(receita.tfj) + parseFloat(receita.iss) + parseFloat(receita.funcivil) + parseFloat(receita.fundo_eletronizacao ?? 0) * receita.quantidade_ato) + acc
      }, 0) ?? 0
    },
  },
  persist: {
    paths: [
      'filtros.filtrarPor',
      'comparacaoReceitas.mesAtual',
      'comparacaoReceitas.periodosComparacao',
      'comparacaoReceitas.atosSelecionados'
    ],
  },
})
